import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { NOTIFICATION } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const initialState = { size: 0, items: [], unreadCount: 0 };

export const getNotificationCount = createAsyncThunk('notifications/unreadCount/fetchAll', async (_, { getState }) => {
	const { notifications } = getState();
	const axios = useAxiosPrivate();

	try {
		const response = await axios.post(NOTIFICATION.GET_NOTIFICATIONS, {
			filter: [
				{
					action: 'isNot',
					key: ['isRead'],
					value: [true]
				},
				{
					action: 'isNot',
					key: ['type'],
					value: ['export']
				}
			],
			paging: { offset: 0, count: 0 }
		});

		if (response.status === 200) {
			if (response.data?.size >= 0) {
				return {
					...notifications,
					unreadCount: response.data.size
				};
			} else {
				return {
					...notifications
				};
			}
		}
	} catch (error) {
		AppLogger.error(error);
	}
});

const notifications = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setNotificationsData: (state, { payload }) => ({
			...state,
			items: payload.data,
			size: payload.size
		}),
		setAllAsRead: (state) => ({
			...state,
			items: state.items.map((item) => ({ ...item, isRead: 1 })),
			unreadCount: 0
		}),
		setNotificationRead: (state, { payload }) => ({
			...state,
			items: state.items.map((item) => {
				if (item.ID === payload) {
					return { ...item, isRead: 1 };
				}
				return item;
			}),
			unreadCount: state.unreadCount > 0 ? state.unreadCount - 1 : 0
		}),
		increaseNotificationCount: (state) => ({
			...state,
			unreadCount: state.unreadCount + 1
		})
	},
	extraReducers: (builder) => {
		builder.addCase(getNotificationCount.fulfilled, (state, { payload }) => payload);
	}
});
export const { setNotificationsData, setAllAsRead, setNotificationRead, increaseNotificationCount } =
	notifications.actions;
export default notifications.reducer;
